import LoaderPage from "src/components/Loader/LoaderPage";
import useAtsPagination from "src/hooks/useAtsPagination";
import { getCompanyAtsApplications } from "src/network/company_ats";
import { AtsApplicationPaginationParams } from "src/network/company_ats/type";
import { AtsApplication, AtsJob } from "src/types/merge_ats";
import PaginatedDiv from "src/components/PaginatedDiv";
import Table from "src/components/Tables/Table";
import { dateFormat1 } from "src/utils/dates/formats";
import { useMemo } from "react";

const Candidates = ({ job }: { job: AtsJob }) => {
  const filters = useMemo(() => ({ job_id: job.id }), [job]);
  const { data, done, fetching, fetch } = useAtsPagination<
    AtsApplication,
    AtsApplicationPaginationParams
  >({
    fetchPage: getCompanyAtsApplications,
    page_size: 10,
    filters
  });

  if (!data) return <LoaderPage />;

  return (
    <PaginatedDiv
      className="!h-auto flex-1 "
      onLimit={fetch}
      loading={fetching}
      // Hardcoded to make this component work with cursor pagination
      count={done ? 0 : 1000}
      currentCount={10}
    >
      <Table
        data={data}
        heads={["Candidate Name", "Email Address", "Source", "Application Date"]}
        row={(a: AtsApplication) => {
          const { appliedAt, candidate, source } = a;
          const { firstName, lastName, emailAddresses } = candidate;
          return [
            `${firstName || ""} ${lastName || ""}`,
            emailAddresses[0]?.value || "N/A",
            source || "N/A",
            dateFormat1(appliedAt)
          ];
        }}
      />
    </PaginatedDiv>
  );
};

export default Candidates;
